export default "__VITE_ASSET___OiXYxc0__"